import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import useFetchSubscriptions from 'asset-actions-lib-forms/editNonHSMailchimpList/hooks/useFetchSubscriptions';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EditNonHSMailchimpListActionButton(props) {
  const {
    crmObject
  } = useAssetActions();
  const formGuid = getPropertyValue(crmObject, 'hs_form_id') || '';
  const {
    data,
    loading
  } = useFetchSubscriptions(formGuid);
  const subscriptionCount = data.filter(subscription => subscription.syncEnabled).length;
  return /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
    children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "extra-small",
      layout: "centered"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "assetActionsLibForms.actions.editMailchimpLists",
      options: {
        count: subscriptionCount
      }
    })
  }));
}